<template>
  <div>
    <!-- fname / lname / email - MembershipForm 风格 -->
    <div class="membership-form-container">
      <div class="signup-form">
        <!-- fname -->
        <div class="form-item-group">
          <div class="form-item-label">
            <label for="user-edit-fname">{{ i18n.t('fname') }}</label>
            <span>{{ i18n.t('nameSub') }}</span>
          </div>
          <div class="form-item-component">
            <SafeInput
              id="user-edit-fname"
              :className="{ 'signup-form-item': true }"
              :type="fnameVisible ? 'text' : 'password'"
              autocomplete="new-password"
              role="input fname"
              :modelValue="localFname"
              :disabled="true"
            />
            <img
              v-show="fnameVisible"
              class="eye"
              :src="eyeOn"
              @click="fnameVisible = false"
              alt="hide fname"
            />
            <img
              v-show="!fnameVisible"
              class="eye"
              :src="eyeOff"
              @click="fnameVisible = true"
              alt="show fname"
            />
          </div>
        </div>

        <!-- lname -->
        <div class="form-item-group">
          <div class="form-item-label">
            <label for="user-edit-lname">{{ i18n.t('lname') }}</label>
            <span>{{ i18n.t('nameSub') }}</span>
          </div>
          <div class="form-item-component">
            <SafeInput
              id="user-edit-lname"
              :className="{ 'signup-form-item': true }"
              :type="lnameVisible ? 'text' : 'password'"
              autocomplete="new-password"
              role="input lname"
              :modelValue="localLname"
              :disabled="true"
            />
            <img
              v-show="lnameVisible"
              class="eye"
              :src="eyeOn"
              @click="lnameVisible = false"
              alt="hide lname"
            />
            <img
              v-show="!lnameVisible"
              class="eye"
              :src="eyeOff"
              @click="lnameVisible = true"
              alt="show lname"
            />
          </div>
        </div>

        <!-- email -->
        <div class="form-item-group">
          <div class="form-item-label">
            <label for="user-edit-email">{{ i18n.t('email') }}</label>
          </div>
          <div class="form-item-component">
            <SafeInput
              id="user-edit-email"
              :className="{ 'signup-form-item': true }"
              :type="emailVisible ? 'text' : 'password'"
              autocomplete="new-password"
              role="input email"
              :modelValue="localEmail"
              :disabled="true"
            />
            <img
              v-show="emailVisible"
              class="eye"
              :src="eyeOn"
              @click="emailVisible = false"
              alt="hide email"
            />
            <img
              v-show="!emailVisible"
              class="eye"
              :src="eyeOff"
              @click="emailVisible = true"
              alt="show email"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 手机号字段 - 可编辑，结构与 FormPhoneSelect 保持一致 -->
    <div class="form-item-mobile-wrapper change-form-item-box-style">
      <div class="form-item-input-wrapper">
        <div class="area-code-wrapper">
          <div class="area-code-wrap">
            <label for="user-edit-area-code" class="form-item-label">
              {{ i18n.t('areaCodeTitle') }}
            </label>
            <div
              id="user-edit-area-code"
              class="area-code-input-wrapper"
              v-clickOutside="popoverOutsideClick"
              @click="toggleAreaList"
            >
              <span>+{{ dialCode }}</span>
              <img src="~img/icon-arrow-down.svg" alt="img-open" />
            </div>
          </div>

          <!-- 手机号输入框 -->
          <div class="area-tel-wrap">
            <label for="user-edit-phone" class="form-item-label">
              {{ i18n.t('mobileNumber') }}
            </label>
            <div class="input-wrapper">
              <SafeInput
                id="user-edit-phone"
                :className="['form-item-input-phone', { 'error-border': phoneErr }]"
                maxlength="15"
                :type="phoneVisible ? 'text' : 'password'"
                autocomplete="new-password"
                v-model="phone"
                @keydown="handlePhoneKeydown"
                @input="e => (phone = e.target.value.replace(/[^\d]/g, '').replace(/\s+/g, ''))"
                data-input-type="mobile"
                role="phone number"
                @blur="onPhoneBlur"
              />
              <img
                class="eye"
                :src="phoneVisible ? eyeOn : eyeOff"
                @click="togglePhoneVisibility"
                alt=""
              />
            </div>
            <p v-if="phoneErr" class="error-msg">{{ phoneErrMsg }}</p>
          </div>
        </div>

        <!-- 区号下拉列表 -->
        <transition name="fade">
          <div class="area-code-popover" v-show="showAreaCodePopover">
            <div class="area-code-popover-content">
              <div class="search-input-wrapper">
                <input
                  type="text"
                  class="search-input"
                  autocomplete="off"
                  v-model="searchText"
                  data-search-type="search"
                />
                <img class="icon-search" src="~img/search-Icon.png" alt="search area code" />
              </div>
              <div class="area-code-list-wrapper">
                <ul class="area-code-list" role="listbox">
                  <li
                    v-for="(ctr, index) in filteredAreaList"
                    :key="`${index}-${ctr.telabbr}`"
                    role="option"
                    class="area-code-item"
                    @click="selectAreaCode(ctr)"
                  >
                    <span class="area-name">{{ ctr.name }}</span>
                    &nbsp;
                    <span class="area-code">(+{{ ctr.telabbr }})</span>
                  </li>
                  <li
                    role="option"
                    class="search-no-results"
                    v-show="filteredAreaList.length === 0"
                  >
                    {{ i18n.t('search-box-no-found') }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import { clickOutside } from '@/utils/directive.js';
  import i18n from '@/i18n';
  import SafeInput from '@/components/SafeInput/index.vue';

  export default {
    name: 'UserEditForm',

    components: { SafeInput },

    directives: { clickOutside },

    props: {
      initialValues: {
        type: Object,
        default: () => ({}),
      },
      errMessage: {
        type: Array,
        default: () => [],
      },
    },

    emits: ['changeFormValue'],

    data() {
      return {
        i18n,
        // 本地副本，避免直接 v-model 绑定 prop
        localFname: '',
        localLname: '',
        localEmail: '',
        // eye 切换状态（初始隐藏）
        fnameVisible: false,
        lnameVisible: false,
        emailVisible: false,
        // 手机号
        phone: '',
        dialCode: '1',
        phoneVisible: false,
        phoneErr: false,
        phoneErrMsg: '',
        showAreaCodePopover: false,
        searchText: '',
        areaList: [],
        eyeOn: require('@/assets/images/icon-feather-eye-on.svg'),
        eyeOff: require('@/assets/images/icon-feather-eye-off.svg'),
      };
    },

    computed: {
      filteredAreaList() {
        const data = this.areaList.filter(ctr => ctr.name && ctr.telabbr && ctr.code);
        if (!this.searchText) return data;
        const searchText = this.searchText.replace('+', '\\+');
        const reg = new RegExp(searchText, 'gi');
        return data.filter(
          ctr => reg.test(ctr.name) || reg.test(ctr.telabbr) || reg.test(ctr.ios2),
        );
      },
    },

    watch: {
      // 初始值变化时同步所有本地字段（页面首次加载用户信息时触发）
      initialValues: {
        handler(val) {
          if (val?.fname !== undefined) this.localFname = val.fname;
          if (val?.lname !== undefined) this.localLname = val.lname;
          if (val?.email !== undefined) this.localEmail = val.email;
          if (val?.phone) this.phone = val.phone;
          if (val?.exphone) this.dialCode = val.exphone;
        },
        immediate: true,
      },

      // 父组件校验错误时，将手机号相关错误显示在组件内
      errMessage: {
        handler(arr) {
          if (!arr || arr.length === 0) {
            this.phoneErr = false;
            this.phoneErrMsg = '';
            return;
          }
          const phoneError = arr.find(err => err.name === 'mobileNumber' || err.name === 'phone');
          if (phoneError) {
            this.phoneErr = true;
            this.phoneErrMsg = phoneError.errMessage;
          } else {
            this.phoneErr = false;
            this.phoneErrMsg = '';
          }
        },
        immediate: true,
      },

      showAreaCodePopover(newVal) {
        if (!newVal) this.searchText = '';
      },
    },

    mounted() {
      this.getAreaList();
    },

    methods: {
      toggleAreaList() {
        this.showAreaCodePopover = !this.showAreaCodePopover;
      },

      togglePhoneVisibility() {
        this.phoneVisible = !this.phoneVisible;
      },

      selectAreaCode(ctr) {
        this.showAreaCodePopover = false;
        this.dialCode = ctr.telabbr;
        this.$emit('changeFormValue', { exphone: ctr.telabbr, phone: this.phone });
      },

      popoverOutsideClick(e) {
        if (e.target.className?.includes?.('search-input')) return;
        if (this.showAreaCodePopover) this.showAreaCodePopover = false;
      },

      // 手机号隐藏时，退格键清空输入（与 FormPhoneSelect 行为一致）
      handlePhoneKeydown(e) {
        if (e.keyCode === 8 && !this.phoneVisible) {
          this.phone = '';
        }
      },

      onPhoneBlur(e) {
        const value = e.target.value;
        this.phoneErr = false;
        this.phoneErrMsg = '';
        this.$emit('changeFormValue', { exphone: this.dialCode, phone: value });
      },

      getAreaList() {
        this.$http.login
          .areaCodeList(localStorage.getItem('lang'))
          .then(res => {
            if (res?.state === '11') {
              this.areaList = Object.freeze(res.list) || [];
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index';
  @use './mobile.scss';
</style>
